import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import MaterialPageItemModule from "../../../modul/MaterialPageItemModule";
import {useEffect, useState} from "react";
import MaterialEstimateUnitService from "../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import MaterialForRequestsCuttingTable from "../../orders/organization/MaterialForRequestsCuttingTable";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";

const steps = [
    'Материал',
    'Комментарий'
];
const ModalAddCustomerRequestCutting = ({
                                            initValue,
                                            open,
                                            onClose,
                                            title,
                                            handleSubmit,
                                            handleModalAlert,
                                            isCustomer,
                                            orderId,
                                            isOrgOne,
                                            loading,
                                            replace
                                        }) => {
    const [activeStep, setActiveStep] = useState(0)
    const [data, setData] = useState(initValue)
    const [materials, setMaterials] = useState([{}])
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    useEffect(() => {
        setData(initValue)
    }, [initValue])

    useEffect(() => {
        open && !isCustomer && !replace && MaterialEstimateUnitService.getAllByOrderIdForRequestsCutting(orderId).then(function (response) {
            let data = response.data;
            setMaterials(data);
            setData(prev => ({...prev, material: data[0]?.id}))
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [open]);

    const submit = () => {
        handleSubmit(data, close)
        setActiveStep(0)
    }
    const close = () => {
        onClose()
        setMaterials([{}])
        setActiveStep(0)
    }
    return (<Dialog open={open} PaperProps={{
        style: {
            minWidth: materials.length === 0 ? 350 : activeStep === 1 ? "750px" : "1400px",
            height: materials.length === 0 ? 300 : activeStep === 1 ? 395 : "885px",
            borderRadius: 8,
        }
    }}>
        <DialogContent sx={{padding: "0px 20px 0px 40px"}}>
            <Box style={{
                padding: 40,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{title}</DialogTitle>
                {isCustomer && <Stepper
                    style={{width: 700}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            {isCustomer ? (activeStep === 0 ? <MaterialPageItemModule
                isOrganization={false}
                selectMaterialId={data?.material}
                selectMaterial={(el) => setData(prev => ({...prev, material: el.id}))}
                typeMaterial={"SLAB"}
                modal={true}
                handleModalAlert={handleModalAlert}
                isOrgOne={isOrgOne}
            /> : <TextFieldValidation
                name="note"
                label="Коментарий"
                value={data?.note}
                setCurrValues={setData}
            />) : replace ? <MaterialPageItemModule
                selectMaterialId={data?.material}
                selectMaterial={(el) => setData(prev => ({...prev, material: el.id}))}
                typeMaterial={"SLAB"}
                modal={true}
                handleModalAlert={handleModalAlert}
                isOrgOne={isOrgOne}
            /> : materials.length === 0 ?
                <Box sx={{display: "flex", justifyContent: "center"}}><Typography>Нет ни одного плитного материала в
                    смете</Typography></Box> :
                <MaterialForRequestsCuttingTable
                    data={materials} tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    selectMaterialId={data?.material}
                    selectMaterial={(el) => setData(prev => ({...prev, material: el.id}))}
                />}
        </DialogContent>
        <DialogActions style={{padding: 40, display: "flex", justifyContent: "flex-end"}}>

            <ButtonExit text={"Выйти"} onClick={close}/>
            {materials.length > 0 && <ButtonAdd
                text={"Выбрать"} loading={loading}
                onClick={() => (activeStep === 0 && isCustomer) ? setActiveStep(1) : submit()}/>}

        </DialogActions>
    </Dialog>)
}
export default ModalAddCustomerRequestCutting